import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dropdown, Message, MessageHeader, Modal } from "semantic-ui-react";
import { responseError } from "../../../../helpers";
import { setSnackbar } from "../../../../actions/snackbar.actions";
import { sysAPI } from "../../../../apis/SysAPI";

const AddOfficeExisting = ({companyProfile, refreshFunction}) => {
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [companies, setCompanies] = useState([]);
    const [companiesIds, setCompaniesIds] = useState([]);
    const me = useSelector((state) => state.me);

    const handleAdd = async () => {
        setLoading(true)
        try {
            const {data} = await sysAPI.post(`/add-offices-in-main-office`, {
                mainOffice: companyProfile._id,
                offices: companiesIds
            })

            setOpenModal(false)
            dispatch(setSnackbar({message: data.message, timeout:10000}))
            refreshFunction()
            setCompaniesIds([])
        } catch (error) {
            responseError(error, undefined, "AddOfficeExisting.handleAdd", dispatch)
        }
        setLoading(false)
    }

    const getCompanies = async () => {
        try {
            const {data} = await sysAPI.get(`/companies-v2`,{
                params:{
                    allCompanies:true
                }
            })
            let auxCompanies = data.data;
            auxCompanies = auxCompanies.filter(e => e.isMainOffice && !e.offices?.length);
            setCompanies(auxCompanies.map(e => ({ key:e._id, text:e.name, value:e._id })))
        } catch (error) {
            responseError(error, undefined, "AddOfficeExisting.handleAdd", dispatch)
        }
    }

    useEffect(() => {
        if(openModal){
            getCompanies()
        }

        // eslint-disable-next-line
    },[openModal])

    if (!me.permissions.includes("companies:add_existing_offices")) {
        return <div></div>;
    }

    return <>
        <Button color="purple" onClick={() => setOpenModal(!openModal)}>Add existing office</Button>

        <Modal size="tiny" open={openModal} onClose={() => setOpenModal(false)} onOpen={() => setOpenModal(true)}>
            <Modal.Header>Add Existing Offices</Modal.Header>
            <Modal.Content>
                <div>
                <Message negative>
                    <MessageHeader>Warning</MessageHeader>
                    <p>This action cannot be undone.</p>
                </Message>
                    <Dropdown
                        fluid
                        placeholder='Search Companies'
                        multiple
                        selection
                        search
                        options={companies}
                        value={companiesIds}
                        onChange={(e, { value }) => {setCompaniesIds(value)}}
                    />
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={() => setOpenModal(false)}>Cancel</Button>
                <Button onClick={handleAdd} color="green" loading={loading}>
                    Add offices
                </Button>
            </Modal.Actions>

        </Modal>
    </>
}

export default AddOfficeExisting;